import React, { useEffect, useRef, useState } from 'react'
import { Modal, Slider } from 'antd'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import { useTranslation } from 'react-i18next'

import { SliderValue } from 'antd/lib/slider'
import {
  StyledButton,
  StyledImg,
  StyledRightButtons,
  StyledSliderDiv,
  StyledWrapImage
} from './styles'

interface Props {
  initPreview: string
  onCancel(): void
}

function validateIsPdf(base64: string): boolean {
  if (!base64) {
    return false
  }

  const mineType = base64.split(';')?.[0]
  return mineType === 'data:application/pdf'
}

function ImagePreview({ preview }: { preview: string }): JSX.Element {
  const { t } = useTranslation()
  const imageRef = useRef<HTMLImageElement>(null)

  if (!preview) {
    return <span />
  }

  const isPdf = validateIsPdf(preview)
  const minScale = 1
  const maxScale = 20

  if (isPdf) {
    return <span>{t('web.receipt.form.images.preview-not-available')}</span>
  }

  return (
    <TransformWrapper
      centerOnInit
      centerZoomedOut
      initialScale={1}
      maxScale={maxScale}
      minScale={minScale}
    >
      {({ centerView, state, zoomIn, zoomOut }): JSX.Element => (
        <StyledWrapImage>
          <TransformComponent>
            <StyledImg
              alt={t('web.receipt.form.images.preview-file')}
              ref={imageRef}
              src={preview}
            />
          </TransformComponent>
          <StyledSliderDiv>
            <Slider
              value={state.scale}
              min={minScale}
              max={maxScale}
              onChange={(value: SliderValue) => {
                centerView(+value || 1)
              }}
            />
          </StyledSliderDiv>
          <StyledRightButtons>
            <StyledButton type="button" onClick={() => zoomIn()}>
              +
            </StyledButton>
            <StyledButton type="button" onClick={() => zoomOut()}>
              -
            </StyledButton>
          </StyledRightButtons>
        </StyledWrapImage>
      )}
    </TransformWrapper>
  )
}

function ThumbnailPreview({ initPreview, onCancel }: Props): JSX.Element {
  const [visible, setVisible] = useState<boolean>(false)

  useEffect(() => {
    setVisible(!!initPreview)
  }, [initPreview])

  return (
    <>
      <Modal
        closable={false}
        footer={null}
        onCancel={() => {
          onCancel()
        }}
        visible={visible}
      >
        <ImagePreview preview={initPreview} />
      </Modal>
    </>
  )
}

export default ThumbnailPreview
